import i18n from "../i18n";

const NS = "categoryLabels";

const getBundle = () => {
    const lng = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
    return i18n.getResourceBundle(lng, NS) || i18n.getResourceBundle("en", NS) || {};
};

export let categoryLabels = {};
export let profileTypeLabels = {};
export let subcategoryLabels = {};
export let subcategoryLabelsMap = {};
export let paramLabels = {};
export let targetLabels = {};
export let aiAppTypeLabels = {};
export let industryLabels = {};
export let subIndustryLabels = {};
export let quickStartTestLabels = {};

const refreshLabels = () => {
    const bundle = getBundle();
    categoryLabels = bundle.categoryLabels || {};
    profileTypeLabels = bundle.profileTypeLabels || {};
    subcategoryLabels = bundle.subcategoryLabels || {};
    subcategoryLabelsMap = bundle.subcategoryLabelsMap || {};
    paramLabels = bundle.paramLabels || {};
    targetLabels = bundle.targetLabels || {};
    aiAppTypeLabels = bundle.aiAppTypeLabels || {};
    industryLabels = bundle.industryLabels || {};
    subIndustryLabels = bundle.subIndustryLabels || {};
    quickStartTestLabels = bundle.quickStartTestLabels || {};
};

refreshLabels();
i18n.on("languageChanged", refreshLabels);

export const allPossibleCategories = [
    {
        "category": "prompts_testing",
        "subcategories": [
        ]
    },
    {
        "category": "regulation_compliance_testing",
        "subcategories": [
        ]
    },
    {
        "category": "rc_gdpr",
        "subcategories": [
            "rc_gdpr_art_5_1_b_6",
            "rc_gdpr_art_12_23",
            "rc_gdpr_art_5_1_c_e",
            "rc_gdpr_art_32_34",
            "rc_gdpr_art_35",
        ]
    },
    {
        "category": "rc_hipaa",
        "subcategories": [
            "rc_hipaa_cfr_164_subpart_e",
            "rc_hipaa_cfr_164_502_b_514_d",
            "rc_hipaa_cfr_164_subpart_c",
            "rc_hipaa_cfr_164_524_526",
        ]
    },
    {
        "category": "rc_pci_dss",
        "subcategories": [
            "rc_pci_dss_req_3_4",
            "rc_pci_dss_req_7_8",
            "rc_pci_dss_req_10_11",
            "rc_pci_dss_req_1_2_6",
        ]
    },
    {
        "category": "rc_eu_ai_act",
        "subcategories": [
            "rc_eu_ai_act_art_5_7_annex_iii",
            "rc_eu_ai_act_art_50",
            "rc_eu_ai_act_art_14",
            "rc_eu_ai_act_art_10_12_11",
        ]
    },
    {
        "category": "rc_owasp_llm",
        "subcategories": [
            "rc_owasp_llm_llm01",
            "rc_owasp_llm_llm02",
            "rc_owasp_llm_llm03_04",
            "rc_owasp_llm_llm05_06",
            "rc_owasp_llm_llm07_10",
        ]
    },
    {
        "category": "rc_nist_ai_rmf",
        "subcategories": [
            "rc_nist_ai_rmf_govern",
            "rc_nist_ai_rmf_map",
            "rc_nist_ai_rmf_measure",
            "rc_nist_ai_rmf_manage",
        ]
    },
    {
        "category": "rc_soc2",
        "subcategories": [
            "rc_soc2_cc6_cc7",
            "rc_soc2_a1",
            "rc_soc2_c1",
            "rc_soc2_pi1_p1_p8",
        ]
    },
    {
        "category": "behavioural_threats",
        "subcategories": [
            "model_drifts",
            "model_poisoning_attempts",
            "multi_step_malicious_intent",
            "model_bias_and_model_influence_attempts",
            "goal_misalignment",
            "unsafe_tool_use",
            "excessive_agency",
            "reward_hacking",
        ]
    },
    {
        "category": "input_output_risks",
        "subcategories": [
            "pii_leakage",
            "confidential_data_leakage_io",
            "output_bias",
            "input_and_output_toxicity",
            "secret_exfiltration",
            "unsafe_output_formatting",
            "hallucinated_authority",
            "sensitive_data_transformation",
        ]
    },
    {
        "category": "policy_compliance_tests",
        "subcategories": [
            "gdpr_privacy_tests",
            "hipaa_tests",
            "owasp_top10_ai_checks",
            "eu_ai_act",
            "ca_ai_acts"
        ]
    },
    {
        "category": "malicious_doc_uploads",
        "subcategories": [
            "word_docs",
            "spreadsheets",
            "powerpoint",
            "jpg_images",
            "png_images",
            "gif_images",
            "qr_codes",
            "pdfs"
        ]
    },
    {
        "category": "llm_api_mis_use_abuse",
        "subcategories": [
            "anomalous_access",
            "dos_rate_limit",
            "abuse_misuse",
            "mitm",
            "dos_burst",
            "invalid_api",
            "api_key_token_abuse"
        ]
    },
    {
        "category": "llm_dos",
        "subcategories": [
            "resource_exhaustion_dos",
            "cost_amplification",
            "service_disruption",
            "memory_exhaustion",
            "token_overflow",
            "rate_limit_bypass",
            "test_context_overflow",
            "test_prompt_injection_dos",
            "test_repetitive_requests",
            "test_session_hijacking_dos",
            "test_burst_attacks",
            "test_slowloris_ai",
            "test_tool_execution_abuse",
            "test_model_poisoning_dos"
        ]
    },
    {
        "category": "mcp_agent",
        "subcategories": [
            "resource_exhaustion_mcpa",
            "protocol_violation",
            "tool_abuse",
            "memory_leak",
            "session_hijack",
            "context_overflow",
            "malicious_tool_calls",
            "test_path_traversal",
            "test_command_injection",
            "test_sql_injection",
            "test_data_exfiltration",
            "test_prompt_injection_mcpa",
            "test_auth_bypass",
            "test_malicious_content",
            "test_session_hijacking_mcpa",
            "test_tool_misuse",
            "test_generic_injection",
            "test_resource_exhaustion",
            "test_benign_requests"
        ]
    },
    {
        "category": "rto_tests",
        "subcategories": [
            "reg_size_prompts",
            "mid_size_prompts",
            "large_size_prompts",
            "doc_upload_tests"
        ]
    },
    {
        "category": "adv_agentic_ai_attacks",
        "subcategories": [
            "adv_crescendo",
            "adv_trolley",
            "adv_frame",
            "adv_rec_pattern",
            "adv_converter"
        ]
    },
    {
        "category": "adv_multi_attacks",
        "subcategories": [
            "ama_backdoor",
            "ama_jb_classic",
            "ama_jb_contextual",
            "ama_decision_fatigue",
            "ama_crisis_manip",
            "ama_collusion",
            "ama_resource_exhaustion",
            "ama_jb_reverse",
            "ama_safe_boundary",
            "ama_jb_sophisticated",
            "ama_info_extraction",
            "ama_jb_token_manip",
            "ama_tool_exploit"
        ]
    },
    {
        "category": "safe_mcp_tests",
        "subcategories": [
            "safe_mcp_protocol",
            "safe_mcp_transport",
            "safe_mcp_tools_disc",
            "safe_mcp_tools_sem",
            "safe_mcp_robust",
            "safe_mcp_ops",
            "safe_mcp_auth",
            "safe_mcp_rate_limit",
            "safe_mcp_concurrency",
            "safe_mcp_session_cancel",
            "safe_mcp_pages",
            "safe_mcp_stream",
            "safe_mcp_encoding",
            "safe_mcp_schema",
            "safe_mcp_input_bounds",
            "safe_mcp_unknown_methods",
            "safe_mcp_resources",
            "safe_mcp_prompt_handling",
            "safe_mcp_observability",
            "safe_mcp_side_effects",
            "safe_mcp_baseline"
        ]
    },
    {
        "category": "prompt_injection",
        "subcategories": [
            "jailbreak",
            "direct_prompt_injections",
            "indirect_prompt_injections",
            "backdoor_triggers",
            "hidden_intent",
            "contextual_drift",
            "benign_prompts",
            "encoding",
            "role_playing",
            "multi_step",
            "system_prompt_extraction",
            "tool_instruction_override",
            "retrieval_context_injection",
        ]
    },
];

const prettifyLabelKey = (key) => {
    if (typeof key !== "string") return key;
    return key
        .replace(/[-_]+/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getCategoryLabel = (category) => {
    return categoryLabels[category] || subcategoryLabelsMap[category] || prettifyLabelKey(category);
};

export const getSubcategoryLabel = (category, subcategory) => {
    return subcategoryLabels[category]?.[subcategory] || prettifyLabelKey(subcategory);
};

// Helper function to get visible tabs based on profile type
export const getVisibleTabsForProfileType = (reportData) => {

    const profileType = reportData?.profile_details_summary?.profile_type || "all";

    switch (profileType) {
        case 'prompts_docs_llm':
            const categories = Object.keys(reportData?.score_json?.data || {});
            if (categories.length === 1 && categories[0] === 'adv_multi_attacks')
                return ['summary', 'failed-tests'];
            else
                return ['summary', 'failed-tests', 'prompts-docs'];
        case 'mcp_tester':
            return ['summary', 'failed-tests', 'mcp-tests'];
        case 'dos_tester':
            return ['summary', 'failed-tests', 'agentic-dos'];
        case 'rto':
            return ['rto'];
        case 'ai_model_attack_surface':
            return ['summary', 'failed-tests', 'ai-model-attack-surface'];
        case 'regulation_compliance':
            return ['summary', 'failed-tests', 'regulation-compliance'];
        default:
            // Default to all tabs if profile type is unknown
            return ['summary', 'failed-tests', 'agentic-dos', 'mcp-tests', 'rto', 'recommendations'];
    }
};
